/* eslint-disable react/prop-types */
//
//
//

import React from "react";
import { useNavigate } from 'react-router-dom';

import { Table } from "react-bootstrap";



function AccountSummary(props) {
  const navigate = useNavigate();


  function onCalender(acct) {
    let path = `/app/planner/accounts/${acct.baseID}/calendar`;
    navigate(path);
  } 

  function onDetails(acct) {
    let path = `/app/planner/accounts/${acct.baseID}/details`;
    navigate(path);
  }


  return (
    <Table size="sm" striped bordered>
      <thead>
        <tr>
          <th>Account</th>
          <th>Starting</th>

          <th>Ending</th>

          <th>Delinquant</th>

          <th>Interest</th>

          <th>Score</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        {props.model.accts.map((account, index) => <AcctDetail key={index} account={account} onCalender={onCalender} onDetails={onDetails}/>)}
      </tbody>
      <tfoot>
        <tr>
          <th>&nbsp;</th>
          <th>{props.model.accts.reduce((prev, cur) => { return prev + cur.startingBal }, 0).toFixed(2)}</th>

          <th>{props.model.accts.reduce((prev, cur) => { return prev + cur.runningBal }, 0).toFixed(2)}</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      </tfoot>
    </Table>
  );

}

function AcctDetail(props) {
  const navigate = useNavigate();


  const handleCalendarClick = (e) => {
    e.preventDefault();
    props.onCalender(props.account);
  }


  const handleDetailsClick = (e) => {
    e.preventDefault();
    props.onDetails(props.account);
  }


  const div_style = {
    display: "inline-block"
  }

  const cal_icon = "fas fa-calendar-alt fa-fw";
  const det_icon = "fas fa-chart-bar fa-fw";


  return (
    <tr>
      <td>{props.account.baseDesc}</td>
      <td>{props.account.startingBal.toFixed(2)}</td>

      <td>{props.account.runningBal.toFixed(2)}</td>

      <td>{props.account.delinquentAmount.toFixed(2)}</td>

      <td>{props.account.totalInterest.toFixed(2)}</td>

      <td>&nbsp;</td>

      <td>
        <div style={div_style}>
          <span onClick={handleCalendarClick}><i className={cal_icon} title="calendar"></i></span>
          <span onClick={handleDetailsClick}><i className={det_icon} title="details"></i></span>
        </div>
      </td>
    </tr>
  );
}


export default AccountSummary;
/* eslint-enable react/prop-types */
